// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20JY7","col":"styles_col__2tUWx","actions":"styles_actions__3DcL3","conflict":"styles_conflict__3Qu95"};